/**
 * 店舗API
 * 店舗の情報を取得
 */

import { apiGet } from './client';
import type { Seller } from '@/lib/types';

// 後方互換性のため、型を再エクスポート
export type { Seller } from '@/lib/types';

/**
 * 店舗一覧を取得
 */
export async function getSellers(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<Seller[]> {
  return apiGet<Seller[]>(`/${accountCode}/sellers`, authHeaders);
}
